import React, { useState, useEffect } from "react";
import { connect } from "react-redux";

function Landing(props) {
  const [state, setState] = useState("");

  useEffect(() => {
    if (props?.user && props?.user?.auth_token) {
      window.location.href = "/dashboard";
    } else {
      window.location.href = "/login";
    }
  }, [props]);

  return <></>;
}

const mapStateToProps = (state) => ({
  user: state.user.user,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(Landing);
